<template>
  <div class="install-desc py-3">
    <div class="container">
      <router-link :to="{'name': 'Intro'}">返回</router-link>
      <InstallDescHeadTitle/>

      <div class="bottom">
        <img class="img-fluid" :src="require('@/assets/images/installDesc/desc.png')"  />

        <div class="pt-4">
          <InstallDescAndroid v-if="!isIOS"/>
          <InstallDescIOS v-if="isIOS"/>
        </div>
      </div>
    </div>

	</div>
</template>

<script>
import InstallDescHeadTitle from "../../components/install/InstallDescHeadTitle.vue";
import InstallDescAndroid from "../../components/install/InstallDescAndroid.vue";
import InstallDescIOS from "../../components/install/InstallDescIOS.vue";

export default {
  name: 'InstallDesc',
  data() {
    return {
    };
  },
  props: {
  },
  components: {
    InstallDescHeadTitle,
    InstallDescAndroid,
    InstallDescIOS,
  },
  computed: {
    
		isIOS: {
			get() {
				const ua = window.navigator.userAgent.toLowerCase();
				console.log(ua);
				return (ua.indexOf('iphone') !== -1) || (ua.indexOf('ipad') !== -1);
			}
		},
	},
  watch: {
  },
  mounted() {
    
	},
  methods: {
    
  },
}
</script>

<style lang="scss" scoped>
@import "src/assets/scss/basic";
.install-desc {
  .bottom {
    padding: 2rem 3rem;
  }
}
</style>
